import React, { ReactNode } from "react";
import { Button, ConfigProvider, Modal } from "antd";

interface ModalComponentProps {
  title: string;
  children?: ReactNode;
  withButton?: boolean;
  buttonText?: string;
  open?: boolean;
  buttonStyle?: React.CSSProperties;
  modalStyle?: React.CSSProperties;
  onClose?: () => void;
  closeOnOutsideClick?: boolean;
  width?: number;
  showCloseIcon?: boolean;
  className?: string;
  centered?: boolean;
  destroyOnClose? : boolean;
}

const ModalComponent: React.FC<ModalComponentProps> = ({
  title,
  children,
  withButton = false,
  buttonText = "Open Modal",
  buttonStyle,
  modalStyle,
  open = false,
  onClose,
  closeOnOutsideClick,
  width,
  showCloseIcon = true,
  className,
  centered,
  destroyOnClose
}) => {
  return (
    <>
      {withButton && (
        <ConfigProvider wave={{ disabled: true }}>
          <Button style={buttonStyle}>{buttonText}</Button>
        </ConfigProvider>
      )}

      <Modal
        // zIndex={2000}
        style={{ top: 20, minHeight: "30vh", height: "30vh", ...modalStyle }}
        width={width}
        open={open}
        footer={null}
        title={title}
        onClose={onClose}
        onCancel={closeOnOutsideClick ? onClose : undefined}
        closable={showCloseIcon}
        className={className}
        centered={centered}
        destroyOnClose={destroyOnClose}
      >
        {children}
      </Modal>
    </>
  );
};

export default ModalComponent;
